import '../../global.d.ts';
import React, { FunctionComponent, lazy, Suspense } from 'react';
import { useTheme } from '@mui/material';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SystemIconsMap = {
  Alarm: lazy(() => import('./icons/Alarm.svg?react')),
  AndroidLogo: lazy(() => import('./icons/AndroidLogo.svg?react')),
  AppleLogo: lazy(() => import('./icons/AppleLogo.svg?react')),
  ShoppingCart: lazy(() => import('./icons/ShoppingCart.svg?react')),
  ShoppingCartSimple: lazy(
    () => import('./icons/ShoppingCartSimple.svg?react'),
  ),
  Seal: lazy(() => import('./icons/Seal.svg?react')),
  Check: lazy(() => import('./icons/Check.svg?react')),
  CheckCircle: lazy(() => import('./icons/CheckCircle.svg?react')),
  Close: lazy(() => import('./icons/Close.svg?react')),
  Trash: lazy(() => import('./icons/Trash.svg?react')),
  FirstTradeTalk: lazy(() => import('./icons/FirstTradeTalk.svg?react')),
  TradeTalkMegaphone: lazy(
    () => import('./icons/TradeTalkMehaphone.svg?react'),
  ),
  Basket: lazy(() => import('./icons/Basket.svg?react')),
  PuzzlePiece: lazy(() => import('./icons/PuzzlePiece.svg?react')),
  Academy: lazy(() => import('./icons/Academy.svg?react')),
  ArrowCircleDown: lazy(() => import('./icons/ArrowCircleDown.svg?react')),
  ArrowsHorizontal: lazy(() => import('./icons/ArrowsHorizontal.svg?react')),
  ArrowCircleDownRight: lazy(
    () => import('./icons/ArrowCircleDownRight.svg?react'),
  ),
  ArrowCircleLeft: lazy(() => import('./icons/ArrowCircleLeft.svg?react')),
  ArrowCircleRight: lazy(() => import('./icons/ArrowCircleRight.svg?react')),
  ArrowCircleUpRight: lazy(
    () => import('./icons/ArrowCircleUpRight.svg?react'),
  ),
  ArrowDown: lazy(() => import('./icons/ArrowDown.svg?react')),
  ArrowLeft: lazy(() => import('./icons/ArrowLeft.svg?react')),
  ArrowRight: lazy(() => import('./icons/ArrowRight.svg?react')),
  ArrowRightMenu: lazy(() => import('./icons/ArrowRightMenu.svg?react')),
  ArrowRightTrading: lazy(() => import('./icons/ArrowRightTrading.svg?react')),
  ArrowUp: lazy(() => import('./icons/ArrowUp.svg?react')),
  ArrowsCounterClockwise: lazy(
    () => import('./icons/ArrowsCounterClockwise.svg?react'),
  ),
  Bell: lazy(() => import('./icons/Bell.svg?react')),
  BellWithDot: lazy(() => import('./icons/BellWithDot.svg?react')),
  BookmarkSimple: lazy(() => import('./icons/BookmarkSimple.svg?react')),
  BookmarkSimpleOutline: lazy(
    () => import('./icons/BookmarkSimpleOutline.svg?react'),
  ),
  BookmarkSimpleUnfilled: lazy(
    () => import('./icons/BookmarkSimpleUnfilled.svg?react'),
  ),
  BoxArrowDown: lazy(() => import('./icons/BoxArrowDown.svg?react')),
  BoxArrowUp: lazy(() => import('./icons/BoxArrowUp.svg?react')),
  Calendar: lazy(() => import('./icons/Calendar.svg?react')),
  CaretDown: lazy(() => import('./icons/CaretDown.svg?react')),
  CaretUp: lazy(() => import('./icons/CaretUp.svg?react')),
  CaretLeft: lazy(() => import('./icons/CaretLeft.svg?react')),
  CaretRight: lazy(() => import('./icons/CaretRight.svg?react')),
  Cart: lazy(() => import('./icons/Cart.svg?react')),
  ChartBarHorizontal: lazy(
    () => import('./icons/ChartBarHorizontal.svg?react'),
  ),
  ChartDonut: lazy(() => import('./icons/ChartDonut.svg?react')),
  ChartPolar: lazy(() => import('./icons/ChartPolar.svg?react')),
  ChatCircle: lazy(() => import('./icons/ChatCircle.svg?react')),
  ChatCircleDots: lazy(() => import('./icons/ChatCircleDots.svg?react')),
  ChatCircleSlash: lazy(() => import('./icons/ChatCircleSlash.svg?react')),
  ChatCircleText: lazy(() => import('./icons/ChatCircleText.svg?react')),
  ChatSlash: lazy(() => import('./icons/ChatSlash.svg?react')),
  ChatTeardrop: lazy(() => import('./icons/ChatTeardrop.svg?react')),
  ChatTeardropDots: lazy(() => import('./icons/ChatTeardropDots.svg?react')),
  ChatTeardropText: lazy(() => import('./icons/ChatTeardropText.svg?react')),
  Clock: lazy(() => import('./icons/Clock.svg?react')),
  ClockCountdown: lazy(() => import('./icons/ClockCountdown.svg?react')),
  ClockClockwise: lazy(() => import('./icons/ClockClockwise.svg?react')),
  Coffee: lazy(() => import('./icons/Coffee.svg?react')),
  ColumnsPlusRight: lazy(() => import('./icons/ColumnsPlusRight.svg?react')),
  ColumnsPlusRightClose: lazy(
    () => import('./icons/ColumnsPlusRight2.svg?react'),
  ),
  CompassNew: lazy(() => import('./icons/CompassNew.svg?react')),
  Community: lazy(() => import('./icons/Community.svg?react')),
  Copy: lazy(() => import('./icons/Copy.svg?react')),
  Coupons: lazy(() => import('./icons/Coupons.svg?react')),
  CreditBalance: lazy(() => import('./icons/CreditBalance.svg?react')),
  CreditCard: lazy(() => import('./icons/CreditCard.svg?react')),
  CrosshairSimple: lazy(() => import('./icons/CrosshairSimple.svg?react')),
  Ctrader: lazy(() => import('./icons/Ctrader.svg?react')),
  Cup: lazy(() => import('./icons/Cup.svg?react')),
  CupFull: lazy(() => import('./icons/CupFull.svg?react')),
  CubeFocus: lazy(() => import('./icons/CubeFocus.svg?react')),
  CubeTransparent: lazy(() => import('./icons/CubeTransparent.svg?react')),
  DiscordLogo: lazy(() => import('./icons/DiscordLogo.svg?react')),
  Dislike: lazy(() => import('./icons/Dislike.svg?react')),
  Edit: lazy(() => import('./icons/Edit.svg?react')),
  EnvelopeOpen: lazy(() => import('./icons/EnvelopeOpen.svg?react')),
  EnvelopeSimpleOpen: lazy(
    () => import('./icons/EnvelopeSimpleOpen.svg?react'),
  ),
  Equalizer: lazy(() => import('./icons/Equalizer.svg?react')),
  Eye: lazy(() => import('./icons/Eye.svg?react')),
  EyeSlash: lazy(() => import('./icons/EyeSlash.svg?react')),
  FacebookLogo: lazy(() => import('./icons/FacebookLogo.svg?react')),
  FacebookLogoBW: lazy(() => import('./icons/FacebookLogoBW.svg?react')),
  Faders: lazy(() => import('./icons/Faders.svg?react')),
  FadersHorizontal: lazy(() => import('./icons/FadersHorizontal.svg?react')),
  FastForwardCircle: lazy(() => import('./icons/FastForwardCircle.svg?react')),
  Feather: lazy(() => import('./icons/Feather.svg?react')),
  FediverseLogo: lazy(() => import('./icons/FediverseLogo.svg?react')),
  File: lazy(() => import('./icons/File.svg?react')),
  Fire: lazy(() => import('./icons/Fire.svg?react')),
  FiversLogo: lazy(() => import('./icons/FiversLogo.svg?react')),
  FullscreenExit: lazy(() => import('./icons/FullscreenExit.svg?react')),
  FunnelSimpleX: lazy(() => import('./icons/FunnelSimpleX.svg?react')),
  Gear: lazy(() => import('./icons/Gear.svg?react')),
  GearFine: lazy(() => import('./icons/GearFine.svg?react')),
  GearSix: lazy(() => import('./icons/GearSix.svg?react')),
  Globe: lazy(() => import('./icons/Globe.svg?react')),
  GlobeFill: lazy(() => import('./icons/Globe_fill.svg?react')),
  GlobeHemisphereWest: lazy(
    () => import('./icons/GlobeHemisphereWest.svg?react'),
  ),
  GoogleLogoBW: lazy(() => import('./icons/GoogleLogoBW.svg?react')),
  HandArrowUp: lazy(() => import('./icons/HandArrowUp.svg?react')),
  Heart: lazy(() => import('./icons/Heart.svg?react')),
  HeartFilled: lazy(() => import('./icons/Heart_Fill.svg?react')),
  HandTap: lazy(() => import('./icons/HandTap.svg?react')),
  HeaderRocket: lazy(() => import('./icons/HeaderRocket.svg?react')),
  HandOk: lazy(() => import('./icons/HandOk.svg?react')),
  Hourglass: lazy(() => import('./icons/Hourglass.svg?react')),
  HourglassHigh: lazy(() => import('./icons/HourglassHigh.svg?react')),
  HourglassLow: lazy(() => import('./icons/HourglassLow.svg?react')),
  HourglassMedium: lazy(() => import('./icons/HourglassMedium.svg?react')),
  ImageBroken: lazy(() => import('./icons/ImageBroken.svg?react')),
  ImageSquare: lazy(() => import('./icons/ImageSquare.svg?react')),
  Images: lazy(() => import('./icons/Images.svg?react')),
  Info: lazy(() => import('./icons/Info.svg?react')),
  InstagramLogo: lazy(() => import('./icons/InstagramLogo.svg?react')),
  Leaf: lazy(() => import('./icons/Leaf.svg?react')),
  Lightbulb: lazy(() => import('./icons/Lightbulb.svg?react')),
  LightbulbFilament: lazy(() => import('./icons/LightbulbFilament.svg?react')),
  Lighthouse: lazy(() => import('./icons/Lighthouse.svg?react')),
  LightningSlash: lazy(() => import('./icons/LightningSlash.svg?react')),
  Link: lazy(() => import('./icons/Link.svg?react')),
  LinkedinLogo: lazy(() => import('./icons/LinkedinLogo.svg?react')),
  LinkSimple: lazy(() => import('./icons/LinkSimple.svg?react')),
  LinkSimpleHorizontal: lazy(
    () => import('./icons/LinkSimpleHorizontal.svg?react'),
  ),
  LinkSimpleHorizontalBreak: lazy(
    () => import('./icons/LinkSimpleHorizontalBreak.svg?react'),
  ),
  LinuxLogo: lazy(() => import('./icons/LinuxLogo.svg?react')),
  ListPlus: lazy(() => import('./icons/ListPlus.svg?react')),
  ListStar: lazy(() => import('./icons/ListStar.svg?react')),
  LockSimple: lazy(() => import('./icons/LockSimple.svg?react')),
  Medal: lazy(() => import('./icons/Medal.svg?react')),
  MedalMilitary: lazy(() => import('./icons/MedalMilitary.svg?react')),
  Megaphone: lazy(() => import('./icons/Megaphone.svg?react')),
  Menu: lazy(() => import('./icons/Menu.svg?react')),
  Metatrader: lazy(() => import('./icons/Metatrader.svg?react')),
  MonitorArrowUp: lazy(() => import('./icons/MonitorArrowUp.svg?react')),
  Moon: lazy(() => import('./icons/Moon.svg?react')),
  MoonOff: lazy(() => import('./icons/MoonOff.svg?react')),
  Pencil: lazy(() => import('./icons/Pencil.svg?react')),
  Plus: lazy(() => import('./icons/Plus.svg?react')),
  PencilSimple: lazy(() => import('./icons/PencilSimple.svg?react')),
  Plug: lazy(() => import('./icons/Plug.svg?react')),
  PlugCharging: lazy(() => import('./icons/PlugCharging.svg?react')),
  Plugs: lazy(() => import('./icons/Plugs.svg?react')),
  PlugsConnected: lazy(() => import('./icons/PlugsConnected.svg?react')),
  Receipt: lazy(() => import('./icons/Receipt.svg?react')),
  RewindCircle: lazy(() => import('./icons/RewindCircle.svg?react')),
  Sailboat: lazy(() => import('./icons/Sailboat.svg?react')),
  Scales: lazy(() => import('./icons/Scales.svg?react')),
  Scissors: lazy(() => import('./icons/Scissors.svg?react')),
  ShareNetwork: lazy(() => import('./icons/ShareNetwork.svg?react')),
  Send: lazy(() => import('./icons/Send.svg?react')),
  ShoppingBag: lazy(() => import('./icons/ShoppingBag.svg?react')),
  SignOut: lazy(() => import('./icons/SignOut.svg?react')),
  SketchLogo: lazy(() => import('./icons/SketchLogo.svg?react')),
  SkipBack: lazy(() => import('./icons/SkipBack.svg?react')),
  SkipForward: lazy(() => import('./icons/SkipForward.svg?react')),
  Skull: lazy(() => import('./icons/Skull.svg?react')),
  SmileyXEyes: lazy(() => import('./icons/SmileyXEyes.svg?react')),
  SortAscending: lazy(() => import('./icons/SortAscending.svg?react')),
  SortDescending: lazy(() => import('./icons/SortDescending.svg?react')),
  SoundcloudLogo: lazy(() => import('./icons/SoundcloudLogo.svg?react')),
  Sparkle: lazy(() => import('./icons/Sparkle.svg?react')),
  Speedometer: lazy(() => import('./icons/Speedometer.svg?react')),
  Spinner: lazy(() => import('./icons/Spinner.svg?react')),
  Spiral: lazy(() => import('./icons/Spiral.svg?react')),
  Star: lazy(() => import('./icons/Star.svg?react')),
  SplitHorizontal: lazy(() => import('./icons/SplitHorizontal.svg?react')),
  SplitVertical: lazy(() => import('./icons/SplitVertical.svg?react')),
  SplitScreen: lazy(() => import('./icons/SplitScreen.svg?react')),
  SunDim: lazy(() => import('./icons/SunDim.svg?react')),
  SunHorizon: lazy(() => import('./icons/SunHorizon.svg?react')),
  Sunglasses: lazy(() => import('./icons/Sunglasses.svg?react')),
  StrategyLong: lazy(() => import('./icons/StrategyLong.svg?react')),
  StrategyShort: lazy(() => import('./icons/StrategyShort.svg?react')),
  StrategyNeutral: lazy(() => import('./icons/StrategyNeutral.svg?react')),
  Tray: lazy(() => import('./icons/Tray.svg?react')),
  TiktokLogo: lazy(() => import('./icons/TiktokLogo.svg?react')),
  The5ersLogo: lazy(() => import('./icons/The5ersLogo.svg?react')),
  TrendingUp: lazy(() => import('./icons/TrendingUp.svg?react')),
  TrendingDown: lazy(() => import('./icons/TrendingDown.svg?react')),
  Unite: lazy(() => import('./icons/Unite.svg?react')),
  User: lazy(() => import('./icons/User.svg?react')),
  UserCircle: lazy(() => import('./icons/UserCircle.svg?react')),
  Users: lazy(() => import('./icons/Users.svg?react')),
  VinylRecord: lazy(() => import('./icons/VinylRecord.svg?react')),
  Warning: lazy(() => import('./icons/Warning.svg?react')),
  WarningCircle: lazy(() => import('./icons/WarningCircle.svg?react')),
  WarningDiamond: lazy(() => import('./icons/WarningDiamond.svg?react')),
  WarningOctagon: lazy(() => import('./icons/WarningOctagon.svg?react')),
  Waveform: lazy(() => import('./icons/Waveform.svg?react')),
  Waves: lazy(() => import('./icons/Waves.svg?react')),
  Wine: lazy(() => import('./icons/Wine.svg?react')),
  WindowsLogo: lazy(() => import('./icons/WindowsLogo.svg?react')),
  Stack: lazy(() => import('./icons/Stack.svg?react')),
  Wrench: lazy(() => import('./icons/Wrench.svg?react')),
  X: lazy(() => import('./icons/X.svg?react')),
  XLogo: lazy(() => import('./icons/XLogo.svg?react')),
  YoutubeLogo: lazy(() => import('./icons/YoutubeLogo.svg?react')),
  Question: lazy(() => import('./icons/Question.svg?react')),
  Coins: lazy(() => import('./icons/Coins.svg?react')),
  ICalendarBlank: lazy(() => import('./icons/ICalendarBlank.svg?react')),
  Trophy: lazy(() => import('./icons/Trophy.svg?react')),
  Trophy2: lazy(() => import('./icons/Trophy-2.svg?react')),
  Badge1: lazy(() => import('./icons/badge-1.svg?react')),
  Badge2: lazy(() => import('./icons/badge-2.svg?react')),
  Badge3: lazy(() => import('./icons/badge-3.svg?react')),
  CornersOut: lazy(() => import('./icons/CornersOut.svg?react')),
  DotsThreeVertical: lazy(() => import('./icons/DotsThreeVertical.svg?react')),
  Confetti: lazy(() => import('./icons/Confetti.svg?react')),
  SealQuestion: lazy(() => import('./icons/SealQuestion.svg?react')),
  Search: lazy(() => import('./icons/Search.svg?react')),
  FunnelSimple: lazy(() => import('./icons/FunnelSimple.svg?react')),
  List: lazy(() => import('./icons/List.svg?react')),
  SquaresFour: lazy(() => import('./icons/SquaresFour.svg?react')),
  SealWarning: lazy(() => import('./icons/SealWarning.svg?react')),
  DownloadSimple: lazy(() => import('./icons/DownloadSimple.svg?react')),
  LockSimpleOpen: lazy(() => import('./icons/LockSimpleOpen.svg?react')),
  Key: lazy(() => import('./icons/Key.svg?react')),
  Midnight: lazy(() => import('./icons/Midnight.svg?react')),
  FrameCorners: lazy(() => import('./icons/FrameCorners.svg?react')),
  Export: lazy(() => import('./icons/Export.svg?react')),
  ChartLineUp: lazy(() => import('./icons/ChartLineUp.svg?react')),
  PushPinSimple: lazy(() => import('./icons/PushPinSimple.svg?react')),
  PushPinSimpleSlash: lazy(
    () => import('./icons/PushPinSimpleSlash.svg?react'),
  ),
  CurrencyCircleDollar: lazy(
    () => import('./icons/CurrencyCircleDollar.svg?react'),
  ),
  ISealPercent: lazy(() => import('./icons/ISealPercent.svg?react')),
  Invoice: lazy(() => import('./icons/Invoice.svg?react')),
  Wallet: lazy(() => import('./icons/Wallet.svg?react')),
  NonEmptyCart: lazy(() => import('./icons/NonEmptyCart.svg?react')),
  Credit5ers: lazy(() => import('./icons/Credit-5ers.svg?react')),
  CreditTtp: lazy(() => import('./icons/Credit-ttp.svg?react')),
  EyeClosed: lazy(() => import('./icons/EyeClosed.svg?react')),
  Headset: lazy(() => import('./icons/Headset.svg?react')),
  RocketLaunch: lazy(() => import('./icons/RocketLaunch.svg?react')),
  ChartLineDown: lazy(() => import('./icons/ChartLineDown.svg?react')),
  Lightning: lazy(() => import('./icons/Lightning.svg?react')),
  IdentificationCard: lazy(
    () => import('./icons/IdentificationCard.svg?react'),
  ),
  Broom: lazy(() => import('./icons/Broom.svg?react')),
  Smiley: lazy(() => import('./icons/Smiley.svg?react')),
  DotsSixVertical: lazy(() => import('./icons/DotsSixVertical.svg?react')),
  Umbrella: lazy(() => import('./icons/Umbrella.svg?react')),
  Whirlwind: lazy(() => import('./icons/Whirlwind.svg?react')),
  XThin: lazy(() => import('./icons/XThin.svg?react')),
  DoubleCaretLeft: lazy(() => import('./icons/DoubleCaretLeft.svg?react')),
  DoubleCaretRight: lazy(() => import('./icons/DoubleCaretRight.svg?react')),
  DollarNote: lazy(() => import('./icons/DollarNote.svg?react')),
  ClockRevert: lazy(() => import('./icons/ClockRevert.svg?react')),
} as const;

export type SystemIconNames = keyof typeof SystemIconsMap;

export const getSystemIconNames = (): SystemIconNames[] => {
  return Object.keys(SystemIconsMap) as SystemIconNames[];
};

export interface SystemIconProps extends Omit<SvgIconProps, 'color'> {
  iconName: SystemIconNames;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | number;
  color?:
    | 'primary'
    | 'secondary'
    | 'action'
    | 'disabled'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'opposite'
    | 'textSecond'
    | (string & {});
}

export const SystemIcon: FunctionComponent<SystemIconProps> = ({
  iconName,
  size = 'medium',
  color,
  ...props
}) => {
  const theme = useTheme();
  const IconComponent = SystemIconsMap[iconName];

  // Get the actual color value from theme or use the provided string
  const getColorValue = (): string => {
    switch (color) {
      case 'primary':
        return theme.palette.primary.main;
      case 'secondary':
        return theme.palette.secondary.main;
      case 'action':
        return theme.palette.action.active;
      case 'disabled':
        return theme.palette.action.disabled;
      case 'error':
        return theme.palette.error.main;
      case 'info':
        return theme.palette.info.main;
      case 'success':
        return theme.palette.success.main;
      case 'warning':
        return theme.palette.warning.main;
      case 'opposite':
        return theme.palette.mode === 'dark' ? 'black' : 'white';
      case 'textSecond':
        return theme.palette.text.secondary;
      default:
        if (typeof color === 'string' && color) {
          return color as string;
        }
        return theme.palette.mode === 'dark' ? 'white' : 'black';
    }
  };

  // Handle size prop
  const getSizeValue = () => {
    if (typeof size === 'number') {
      return size;
    }

    switch (size) {
      case 'xsmall':
        return 16;
      case 'small':
        return 20;
      case 'large':
        return 32;
      case 'medium':
      default:
        return 24;
    }
  };

  const colorValue = getColorValue();
  const sizeValue = getSizeValue();

  return (
    <Suspense fallback={null}>
      <SvgIcon
        inheritViewBox
        {...props}
        sx={{
          fontSize: sizeValue,
          color: colorValue,
          // Apply color more selectively to avoid making icons "fat"
          '& path[fill]:not([fill="none"])': {
            fill: colorValue,
          },
          '& path[stroke]:not([stroke="none"])': {
            stroke: colorValue,
          },
          '& circle[fill]:not([fill="none"])': {
            fill: colorValue,
          },
          '& circle[stroke]:not([stroke="none"])': {
            stroke: colorValue,
          },
          '& rect[fill]:not([fill="none"])': {
            fill: colorValue,
          },
          '& rect[stroke]:not([stroke="none"])': {
            stroke: colorValue,
          },
          '& line': {
            stroke: colorValue,
          },
          '& polygon[fill]:not([fill="none"])': {
            fill: colorValue,
          },
          '& polygon[stroke]:not([stroke="none"])': {
            stroke: colorValue,
          },
          '& polyline': {
            stroke: colorValue,
          },
          // For icons with currentColor, use the color property
          '& [fill="currentColor"]': {
            fill: colorValue,
          },
          '& [stroke="currentColor"]': {
            stroke: colorValue,
          },
          ...props.sx,
        }}
        component={IconComponent}
      />
    </Suspense>
  );
};
